import type { AdjustmentReportItemDto } from "@/api/dtos";
import type { AdjustmentReportItem } from "@/api/report/_models/AdjustmentReport";

/** DTO → domain for an adjustment report row. */
export const toAdjustmentReportItemFromDto = (dto: AdjustmentReportItemDto): AdjustmentReportItem => {
  return {
    date: dto.date,
    item: dto.item,
    quantity: dto.quantity,
    reason: dto.reason,
  };
};
